import {apiSlice} from './apiSlice';

/**
 * Endpoints module Google Trends — xu hướng tìm kiếm theo quốc gia (RSS công khai).
 *
 * - getTrends: danh sách từ khoá đang thịnh hành của 1 geo (BE cache chung 15 phút
 *   theo geo + enrich "đã trend X ngày" từ snapshot). Nút "Làm mới" dùng refetch().
 * - getTrendsHistory: snapshot của 1 ngày trong quá khứ (bảng trend_snapshots).
 *
 * Query-only — lưu từ khoá vào kho đi qua addKeywordItems của keywordApiSlice
 * (source: 'trends') nên không cần tagType riêng.
 */
export const trendsApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getTrends: builder.query({
			query: (geo = 'VN') => ({url: 'trends', method: 'get', params: {geo}}),
			transformResponse: (body) => body?.data || null,
			keepUnusedDataFor: 300,
		}),
		getTrendsHistory: builder.query({
			query: ({geo = 'VN', date} = {}) => ({
				url: 'trends/history',
				method: 'get',
				params: {geo, ...(date ? {date} : {})},
			}),
			transformResponse: (body) => body?.data || null,
		}),
		// Chuỗi ngày 1 từ khoá xuất hiện trong bảng trending (30 ngày) — biểu đồ tần suất.
		getTrendsKeywordHistory: builder.query({
			query: ({geo = 'VN', hash}) => ({
				url: 'trends/keyword-history',
				method: 'get',
				params: {geo, hash},
			}),
			transformResponse: (body) => body?.data || null,
		}),
	}),
});

export const {
	useGetTrendsQuery,
	useGetTrendsHistoryQuery,
	useGetTrendsKeywordHistoryQuery,
} = trendsApiSlice;
